import {apiCall} from "../store/services/service";
import {URL_PAYROLL_ACCOUNT_TYPES, URL_SERVICE_TYPES} from "../store/services/URL";

export function serviceTypesRequest(params) {
    return apiCall.get({
        url: URL_SERVICE_TYPES,
        isAuthToken: true,
        params: params || {},
    });
}

export function payrollAccountTypesRequest(params) {
    return apiCall.get({
        url: URL_PAYROLL_ACCOUNT_TYPES,
        isAuthToken: true,
        params: params || {},
    });
}


export default {
    // ...other methods
    serviceTypesRequest,
};